<template>
    <div class="field" :class="{'is-error': isInvalid}" v-fs-block>
        <label v-if="label" class="field-label">{{label}}</label>
        <r-tabs content-class="no-padding" menu-class="no-margin-bottom" @tab-selected="activatePreview">
            <r-tab name="HTML" :active="true">
                <r-input
                    :value="value"
                    @input="update"
                    :multiline="true"
                    rows="10"/>
            </r-tab>
            <r-tab name="Preview">
                <div>
                    <v-iframe-sandbox ref="preview" class="invoice-body" :html="html"/>
                </div>
            </r-tab>
        </r-tabs>
        <span class="field-caption">Content preview will not display embedded content live for security reasons.</span>
    </div>
</template>

<script>
    import vIframeSandbox from '@/components/v-iframe-sandbox';

    export default {
        name: 'v-editor',
        components: {vIframeSandbox},
        props: {
            value: [String, Object],
            label: String,
            helpText: String,
            toolbar: {
                type: Array,
                default: () => [
                    [{header: [1, 2, 3, false]}],
                    [
                        'bold',
                        'italic',
                        'underline',
                        'strike',
                    ],
                    ['link'],
                    [{color: []}, {background: []}],
                    [{align: []}],
                    [
                        {list: 'ordered'},
                        {list: 'bullet'},
                        {indent: '-1'},
                        {indent: '+1'},
                    ],
                ],
            },
        },
        computed: {
            isInvalid() {
                // TODO
                return false;
            },
            html() {
                return `<div>${this.value}</div>`;
            },
        },
        methods: {
            update(content) {
                this.$emit('input', content);
            },
            /**
             * Force sandbox to recalculate the inner iframe's height when the content is updated.
             * This is required after the value of the editor is modified. Otherwise it won't scale innately.
             * @param {number} index
             */
            activatePreview({index}) {
                if (index === 1) {
                    this.$nextTick(() => this.$refs.preview.refresh());
                }
            },
        },
    };
</script>

<style scoped>

</style>
